export enum DependentVerificationStatusTypeEnum {
    CompleteEligible = 1,
    NoResponse = 2,
    IncompleteInsufficientDocumentation = 3,
    CompleteIneligibleByEmployeeReq = 4,
    CompleteIneligible = 5,
    IncompleteNoDependentSSN = 6,
    IncompleteNoStudentVerification = 7,
    None = 8,
    Appealed = 9,
}
